import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Row } from "react-bootstrap";
import { FcGoogle } from "react-icons/fc";
import "./Navbar.css";

const Ai = () => {
  return (
    <>
      <Row
        className="bix-tracker-section justify-content-center mx-0"
      >
        <Col xs={12} md={10} className="px-3 px-sm-4">
          <Row className="align-items-center gy-4 gy-md-0">
            <Col
              xs={12}
              md={6}
              className="d-flex flex-column justify-content-center align-items-start"
            >
              <div className="bix-tracker-content">
              
                <h2 className="bix-tracker-title">
                  <b>
                    Smart Tracking, Better Results
                    <br /> Only with
                    <span style={{ color: "#3C74F6" }}> Bix Tracker</span>{" "}
                  </b>
                </h2>
                <p
                  className="bix-tracker-description mt-3"
                >
                 Bix Tracker is an all in one tracking and growth management tool designed to help businesses stay organized, make data driven decisions and achieve better results.

                </p>
                <div className="hero-actions mt-4 d-flex flex-column flex-sm-row flex-wrap gap-3">
                  <Button
                    className="hero-action-button"
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/", "_blank")
                    }
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FcGoogle size={20} />
                    <span>Start free with Google</span>
                  </Button>

                  <Button
                    className="hero-action-button"
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/")
                    }
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                    }}
                  >
                    Book a Demo
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-center align-items-center"
            >
              <img
                src={require("../Images/bix-tracker.webp")}
                alt="Bix Tracker dashboard preview"
                width="700"
                height="350"
                className="bix-tracker-image"
                loading="lazy"
                decoding="async"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Ai;
